export const homepageUrl = "/";
export const hpPlanningUrl = "/hp-test/";
